import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <div className="sidebar">
      <h2>ERP</h2>
      <ul>
        <li>
          <Link to="/">Create Invoice</Link>
        </li>
        <li>
          <Link to="/add-item">Add New Item</Link>
        </li>
        <li>
        <Link to="/item-mapping">Item Mapping</Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;